import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import io from 'socket.io-client';
import ViewSubCategories from './SubCategories';
import { viewAllRecordCategory } from '../../services/categoriesServives';
import { addRecord } from '../../services/subCategoriesServives';

function SubCategories(props) {
  const [name, setName] = useState('');
  const [catName, setCatName] = useState('');
  const [nameError, setNameError] = useState('');
  const [cateNameError, setCatNameError] = useState('');
  const [categories, setCategories] = useState([]);
  const baseURL = process.env.REACT_APP_BASE_URL_DOCUMENT;

  useEffect(() => {
    async function clientSocket() {
      // Socket for getting category record
      const socket = io(baseURL);
      socket.on('category', (ms) => {
        getCat();
      });
    }
    clientSocket();
    getCat();
  }, []);

  async function handleSubmit() {
    if (name === '' || catName === '') {
      if (name === '') {
        setNameError('Sub category name is required');
      } else {
        setNameError(null);
      }
      if (catName === '') {
        setCatNameError('Category name is required');
      } else {
        setCatNameError(null);
      }
    } else {
      setNameError(null);
      setCatNameError(null);
      addData();
    }
  }

  async function addData() {
    addRecord(name, catName)
      .then((response) => {
        const socket = io(baseURL);
        const userId = Cookies.get('creadUseDetail');
        socket.emit('subCategory', `${userId}`);
      })
      .catch((error) => {
        if (error.response.data.userError) {
          Cookies.remove('token');
          Cookies.remove('creadUseDetail');
          props.history.push('/');
          window.location.reload();
        }
      });
  }

  async function getCat() {
    viewAllRecordCategory()
      .then((response) => {
        setCategories(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  return (
    <div className="content-wrapper">
      <div>
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1></h1>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-12">
                <div className="card">
                  {/* /.card-header */}
                  <div className="card-body">
                    <div className="form-row">
                      <div className="col-12 form-group">
                        <label>
                          Category list<i className="required-detail">*</i>
                        </label>
                        <select
                          className="form-control"
                          name={catName}
                          onChange={(e) => setCatName(e.target.value)}
                        >
                          <option value="">Select category</option>
                          {categories.map((detail) => (
                            <option key={detail._id} value={detail._id}>
                              {detail.name}
                            </option>
                          ))}
                        </select>

                        {cateNameError ? (
                          <p className="errorMessage"> {cateNameError}</p>
                        ) : null}
                      </div>
                      <div className="col-12 form-group">
                        <label>
                          Add Sub Category<i className="required-detail">*</i>
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name={name}
                          placeholder="Sub Category name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        {nameError ? (
                          <p className="errorMessage"> {nameError}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="card-header">
                    <h3 className="card-title">
                      <Link
                        to="#"
                        onClick={() => handleSubmit()}
                        className="btn btn-info mr-2"
                      >
                        Add New Record
                      </Link>
                    </h3>
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
                {/* /.card */}
              </div>
              <ViewSubCategories />

              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
    </div>
  );
}

export default SubCategories;
